import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  inject,
  Input,
  ViewChild,
} from '@angular/core';

import { ButtonBarComponent } from '@blaze-shared/shared-ui';

@Component({
  selector: 'blaze-cell-preview',
  imports: [ButtonBarComponent],
  templateUrl: './cell-preview.component.html',
  styleUrls: ['./cell-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellPreviewComponent {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('contentContainer') contentContainer?: ElementRef<HTMLDivElement>;
  @HostBinding('class.expanded') isExpanded = false;

  contentValue: unknown = '';
  canExpand = false;

  @Input() set content(value: unknown) {
    this.contentValue = value;
    this.determineExpandButtonVisibility();
  }

  get expandButtonLabel(): string {
    return this.isExpanded ? 'See less' : 'See more';
  }

  determineExpandButtonVisibility(): void {
    this.isExpanded = false;

    requestAnimationFrame(() => {
      const { scrollHeight = 0, clientHeight = 0 } = this.contentContainer?.nativeElement || {};
      this.canExpand = scrollHeight > clientHeight;
      if (!this.canExpand) {
        this.isExpanded = false;
      }
      this.cdr.detectChanges();
    });
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }
}
